import { z } from "zod";
import { ZDate } from "./ZDate.js";
import { zObj } from "./zodWrapper.js";
export const Interval = zObj({
    gte: ZDate,
    lt: ZDate,
});
export const CSV_DOWNLOAD_MAX_SENSORS = 15;
export const CSV_DOWNLOAD_MAX_DAYS = 92;
export const JsonData = z.union([z.record(z.any()), z.array(z.any()), z.string(), z.number(), z.boolean()]);
//# sourceMappingURL=common.js.map